import { CreateProduct, Product } from "../types/working-model";
import { Delete, Get, Post, Put } from "./helpers";

export function GetProducts(
  token: string,
  channel: number
): Promise<Product[]> {
  return Get(`/v3/admin/channel/products/${channel}`, token);
}

export function InsertProduct(
  token: string,
  product: CreateProduct,
  languages?: string[]
): Promise<Product> {
  return Post(`/v3/admin/channel/products/`, token, { product, languages });
}

export function UpdateProduct(
  token: string,
  product: Product,
  languages?: string[]
): Promise<Product> {
  return Put(
    `/v3/admin/channel/products/`,
    token,
    { product, languages },
    true
  );
}

export function DeleteProducts(
  productIDs: number[],
  token: string,
  channel: number
): any {
  return Delete(
    `/v3/admin/channel/products`,
    token,
    { productIDs, channel },
    true
  );
}
